const LoadsServiceFactory = ({ HTTPDeviations }) => {
    return {
        getAlertsSummary: (farmId) => {
            return HTTPDeviations.get(`farm/${farmId}/dashboard/feeding/loads/alerts/summary`).then((res) => res.data);
        },
        getAlerts: (farmId) => {
            return HTTPDeviations.get(`farm/${farmId}/dashboard/feeding/loads/alerts`).then((res) => res.data);
        },
        getDeviations: (farmId, ingredientId) => {
            return HTTPDeviations.get(`farm/${farmId}/dashboard/feeding/loads/deviations/${ingredientId}`).then((res) => res.data);
        },
        deleteAlerts: (farmId, ids) => {
            return HTTPDeviations.post(`farm/${farmId}/dashboard/feeding/loads/alerts/clear?ingredientIds=${ids.join(',')}`);
        },
        deleteItemAlerts: (farmId, ingredientId) => {
            return HTTPDeviations.post(`farm/${farmId}/dashboard/feeding/loads/alerts/${ingredientId}/clear`);
        },
    };
};
export default LoadsServiceFactory;
//# sourceMappingURL=loads.api.js.map